import GameState from "slotworks/model/game-state";
import GambleInitRequestPayload from "slotworks/model/gameplay/requests/gamble-init-request";
import CommsManager from "slotworks/server/comms-manager";
import Contract from "slotworks/utils/contracts/contract";

export function GambleInitCommand(): Contract<void> {
    const payload = new GambleInitRequestPayload();
    const record = GameState.getCurrentGame().getCurrentRecord();
    payload.gambleID = record.gambleID;
    payload.stake = record.gambleStake;

    return CommsManager.request(payload);
}
